import $ from 'jquery';
import isInViewport from '../../utils/inView';

$(window).on('load scroll', function () {
	$('.ucg-fade-in-up').each(function () {
		if (isInViewport($(this))) {
			$(this).addClass('animate');
		}
	});
});
